<div class="surface-800" *ngIf="news">
	<p-divider align="center" styleClass="surface-800">
		<h1 class="text-primary mx-2 uppercase surface-800">NEWS</h1>
	</p-divider>
	<div class="grid news  p-2">
		<ng-container *ngFor="let item of news">
			<!-- <a [routerLink]="['news/'+item.id_page]" class="p-2 sm:col-6 md:col-3 col-12" [innerHTML]="item.imgs[0]" *ngIf="item.from == 'admin' && item.imgs &&  item.imgs[0]"></a> -->
			<div *ngIf="item.from == 'admin' && item.imgs &&  item.imgs[0]" class="p-2 sm:col-6 md:col-3 col-12">
				<div class="surface-card h-full flex flex-column justify-content-between wpNews">

					<a [routerLink]="['news/'+item.id_page]" [innerHTML]="item.imgs[0]">
						<img [src]="item.img" />
					</a>


					<a [routerLink]="['news/'+item.id_page]" class="mb-2 text-white text-right block">
						En savoir plus...
					</a>
				</div>
			</div>
			<div *ngIf="item.from == 'wp'" class="p-2 sm:col-6 md:col-3 col-12">
				<div class="surface-card h-full flex flex-column justify-content-between wpNews">

					<a [routerLink]="['pages/'+item.slug]">
						<img [src]="item.img" />
					</a>
					<h2 class="text-center" [innerHTML]="item.title"></h2>


					<a [routerLink]="['pages/'+item.slug]" class="mb-2 text-white text-right block">
						{{'En savoir plus...' | translate}}
					</a>
				</div>
			</div>
		</ng-container>
	</div>

</div>
<div class="bloc {{i % 2 == 0 ? 'surface-card' : 'surface-800'}}" *ngFor="let bloc of blocs; let i = index">
	<p-divider align="center" styleClass="{{i % 2 == 0 ? 'surface-card' : 'surface-800'}}">
		<h1 class="text-primary mx-2 uppercase {{i % 2 == 0 ? 'surface-card' : 'surface-800'}}">{{bloc.name | translate}}</h1>
	</p-divider>
	<p-carousel *ngIf="bloc.games.length > 4" [circular]="true" [value]="bloc.games" [numVisible]="4" [numScroll]="1" [showNavigators]="true" [showIndicators]="false" [responsiveOptions]="responsiveOptions">
		<ng-template let-game pTemplate="item">
			<div class="text-center p-2">
				<app-bloc-game [game]="game" class="{{i % 2 == 0 ? '' : 'white'}}"></app-bloc-game>
			</div>
		</ng-template>
	</p-carousel>
	<div class="text-center grid" *ngIf="bloc.games.length < 5">
		<div class="sm:col-6 md:col-3 col-12 " *ngFor="let game of bloc.games">
			<div class="text-center p-2">
				<app-bloc-game [game]="game" class="{{i % 2 == 0 ? '' : 'white'}}"></app-bloc-game>
			</div>
		</div>
	</div>
</div>